import { render, staticRenderFns } from "./StandbysDailyAssignments.vue?vue&type=template&id=5b20c24b&scoped=true&"
import script from "./StandbysDailyAssignments.vue?vue&type=script&lang=js&"
export * from "./StandbysDailyAssignments.vue?vue&type=script&lang=js&"
import style0 from "./StandbysDailyAssignments.vue?vue&type=style&index=0&id=5b20c24b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b20c24b",
  null
  
)

export default component.exports